import React, { Component } from 'react';

import Link from '../../../../shared/components/hyperlink'

import '../right-rail.less';


class ArticleArchives extends Component {

  constructor(props) {
    super(props);
    this.state = {
      articleArchives: [],
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(nextProps.articleArchives && Object.keys(nextProps.articleArchives).length) {

      const { hits:articleArchives } = nextProps.articleArchives;
      const { hits, total:totalHits } = articleArchives || {};

      let blogs = hits.map((hit) => {
        return hit['_source'];
      });

      return {
        articleArchives: blogs,
      }

    }
    return null;
  }

  render() {

    const {articleArchives} = this.state;

    return (
      <div className="article-archives">
      { articleArchives.length > 0 &&
        <span>
        <h3>Article archives</h3>
        <hr/>
        <ul>
        {
          articleArchives.map((article, index) => {
            const {vanityUrl, blogTitle} = article;
            return (
              <li key={index}><Link to={`/${vanityUrl}`}><span>{blogTitle  + " >"}</span></Link></li>
            );
          })
        }
        </ul>
        </span>
      }
      </div>


    )
  }

}

export default ArticleArchives;
